// test102
(102 && 0);
